// extracted by mini-css-extract-plugin
export default {"block":"Navbar_block__FhERF","grow":"Navbar_grow__4ZTqf","navbarBody":"Navbar_navbarBody__9ljJD","scrolled":"Navbar_scrolled__Nzs+4","homeButtonLogo":"Navbar_homeButtonLogo__zAdmh"};